import React, { useState, useRef, useEffect } from "react";
import { HelpCircle } from "lucide-react";

export default function InfoTooltip({ text, label, className = "" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  return (
    <span className={`relative inline-flex ${className}`} ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        onMouseEnter={() => setOpen(true)}
        data-testid="info-tooltip-trigger"
        className="inline-flex items-center gap-1 text-xs text-blue-700 hover:text-blue-900"
      >
        {label && <span className="underline decoration-dotted underline-offset-2">{label}</span>}
        <HelpCircle className="w-3.5 h-3.5 stroke-[1.5]" />
      </button>
      {open && (
        <span
          className="absolute left-0 top-full mt-1.5 z-30 w-64 p-3 text-xs leading-relaxed text-zinc-700 bg-white border border-zinc-200 rounded-sm shadow-lg"
          onMouseLeave={() => setOpen(false)}
        >
          {text}
        </span>
      )}
    </span>
  );
}
